const Table = ELEMENT.Table;

if (!Table.render_override) {
  const render = Table.render;
  const doLayout = Table.methods.doLayout;

  Table.methods.doLayout = function () {
    doLayout.call(this);
    this.$nextTick(() => {
      splitTableFooter.call(this);
    })
  }
  Table.render = function (h) {
    let vnodes = render.call(this, h);
    if (vnodes.children) {
      //修复el-table存在汇总行和固定行头时el-table__fixed遮挡滚动条的问题
      let index = _.findIndex(vnodes.children, (vn) => {
        return vn?.data?.staticClass == "el-table__fixed"
      });
      let fixed = vnodes.children[index];
      if (fixed) {
        let footer = _.find(fixed.children || [], (it) => it?.data?.staticClass == "el-table__fixed-footer-wrapper");
        if(footer){
          dsf.array.remove(fixed.children, footer);
          let footerVnode = h('div', {
            ref: 'fixedWrapperFooter',
            staticClass: 'el-table__fixed_footer'
          }, [footer]);
          vnodes.children.splice(index + 1, 0, footerVnode);
        }
      }
    }
    return vnodes;
  }
  Table.render_override = true;
}
function splitTableFooter() {
  if (this.$refs.fixedWrapperFooter) {
    let fixedHeaderHeight = this?.$refs?.fixedHeaderWrapper?.offsetHeight || 0;
    let fixedBodyHeight = this?.$refs?.fixedBodyWrapper?.offsetHeight || 0;
    let fixed=this.$refs.fixedWrapper;
    if(fixed){
      this.$refs.fixedWrapper.style.height = this.unitSize(fixedHeaderHeight + fixedBodyHeight+2);
      this.$refs.fixedWrapperFooter.style.width = this.unitSize(this.$refs.fixedWrapper.offsetWidth);
      this.$refs.fixedWrapperFooter.style.height = this.unitSize(this.$refs.fixedFooterWrapper.offsetHeight);
    }
    
  }

}